import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-role-su-school-or-district",
	templateUrl: "./role-su-school-or-district.component.html",
	styleUrls: ["./role-su-school-or-district.component.css"],
})
export class RoleSuSchoolOrDistrictComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef) {}

	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.School;
		this.UserCount = this.dialogConfig.data.UserCount;

		this.RoleDesc = this.dialogConfig.data.RoleDesc;
		this.SchoolName = this.SelectedSchool.SchoolName;
		this.SchoolFullName = this.SelectedSchool.SchoolNumber + " - " + this.SelectedSchool.SchoolName;
	}

	/////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////

	SelectedSchool: any;

	RoleDesc: string;
	SchoolName: string = "";
	SchoolFullName: string = "";
	UserCount: number = 0;

	/////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////

	onSchool() {
		this.ref.close(this.SelectedSchool.SchoolID);
	}

	onDistrict() {
		this.ref.close(-1);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////
}
